(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection"]) return;
  try {
    
(function() {
  const CollectionScroller = class {
    constructor(section) {
      this.section = section;
      this.content = this.section.querySelector('.horizontal-collection__content');
      this.sensitivity = parseFloat(this.section.dataset.scrollSensitivity) || 1.5;
      this.enabled = true;
      this.onWheel = this.onWheel.bind(this);
      this.init();
    }

    init() {
      if (typeof gsap === 'undefined') {
        console.warn('GSAP not loaded. Retrying...');
        setTimeout(() => this.init(), 100);
        return;
      }
      gsap.set(this.content, { x: 0 });
      window.addEventListener('wheel', this.onWheel, { passive: false });
    }

    onWheel(e) {
      if (!this.enabled) return;
      
      // Only prevent default on desktop
      const isDesktop = window.matchMedia('(min-width: 1024px)').matches;
      if (!isDesktop) return;
      
      e.preventDefault();
      
      const maxScroll = this.content.scrollWidth - this.section.offsetWidth;
      const currentX = gsap.getProperty(this.content, "x");
      const newX = currentX - (e.deltaY * this.sensitivity);
      const clampedX = gsap.utils.clamp(-maxScroll, 0, newX);
      
      gsap.to(this.content, { 
        x: clampedX, 
        duration: 1, 
        ease: "power2.out" 
      });
    }

    onUnload() {
      window.removeEventListener('wheel', this.onWheel);
      if (this.content) gsap.killTweensOf(this.content);
    }
  };

  const initCollectionScroller = (section) => {
    const isDesktop = window.matchMedia('(min-width: 1024px)').matches;
    
    if (isDesktop) {
      if (typeof gsap === 'undefined') {
        setTimeout(() => initCollectionScroller(section), 100);
        return;
      }

      const sectionId = section.dataset.sectionId;
      if (!window.collectionScrollerInstances) window.collectionScrollerInstances = {};
      
      if (window.collectionScrollerInstances[sectionId]) {
        window.collectionScrollerInstances[sectionId].onUnload();
      }

      document.body.classList.add('body-no-scroll');
      const scroller = new CollectionScroller(section);
      window.collectionScrollerInstances[sectionId] = scroller;
    } else {
      document.body.classList.remove('body-no-scroll');
    }
  };

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.horizontal-collection-section').forEach(initCollectionScroller);
  });

  document.addEventListener('shopify:section:load', (e) => {
    if (e.target.querySelector('.horizontal-collection-section')) {
      initCollectionScroller(e.target.querySelector('.horizontal-collection-section'));
    }
  });

  document.addEventListener('shopify:section:unload', (e) => {
    const section = e.target.querySelector('.horizontal-collection-section');
    if (section) {
      const sectionId = section.dataset.sectionId;
      if (window.collectionScrollerInstances && window.collectionScrollerInstances[sectionId]) {
        window.collectionScrollerInstances[sectionId].onUnload();
        delete window.collectionScrollerInstances[sectionId];
        if (Object.keys(window.collectionScrollerInstances).length === 0) {
          document.body.classList.remove('body-no-scroll');
        }
      }
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["scroller"] && !Shopify.designMode) return;
  try {
    
(function() {
  const Scroller = class {
    constructor(section) {
      this.section = section;
      this.content = this.section.querySelector('.horizontal-scroller__content');
      this.sensitivity = parseFloat(this.section.dataset.scrollSensitivity) || 1.0;
      this.enabled = true;
      this.onWheel = this.onWheel.bind(this);
      this.init();
    }
    init() {
      gsap.set(this.content, { x: 0 });
      window.addEventListener('wheel', this.onWheel, { passive: false });
    }
    onWheel(e) {
      if (!this.enabled) return;
      e.preventDefault();
      const maxScroll = this.content.scrollWidth - this.section.offsetWidth;
      const currentX = gsap.getProperty(this.content, "x");
      const newX = currentX - (e.deltaY * this.sensitivity);
      const clampedX = gsap.utils.clamp(-maxScroll, 0, newX);
      gsap.to(this.content, { x: clampedX, duration: 1, ease: "power2.out" });
    }
    onUnload() {
      window.removeEventListener('wheel', this.onWheel);
      if (this.content) gsap.killTweensOf(this.content);
    }
  };

  const DraggableStickers = class {
    constructor(stickerLayer, scrollerInstance) {
      this.layer = stickerLayer;
      this.scroller = scrollerInstance;
      this.stickers = this.layer.querySelectorAll('[data-sticker-item]');
      this.draggableInstances = [];
      this.init();
    }
    init() {
      this.stickers.forEach(sticker => {
        const instance = Draggable.create(sticker, {
          type: "x,y",
          bounds: this.scroller ? this.scroller.content : this.layer.parentElement,
          inertia: true,
          edgeResistance: 0.85,
          onPress: () => {
            if (this.scroller) this.scroller.enabled = false;
            gsap.to(sticker, { scale: 1.2, rotation: gsap.utils.random(-15, 15), duration: 0.2 });
          },
          onRelease: () => {
            if (this.scroller) this.scroller.enabled = true;
            gsap.to(sticker, { scale: 1, rotation: 0, ease: "back.out(2)", duration: 0.3 });
          }
        });
        this.draggableInstances.push(instance[0]);
      });
    }
    destroy() {
      this.draggableInstances.forEach(instance => {
        if (instance && instance.kill) instance.kill();
      });
      this.draggableInstances = [];
    }
  };

  const initFullScroller = (section) => {
    if (typeof gsap === 'undefined' || typeof Draggable === 'undefined') {
      setTimeout(() => initFullScroller(section), 100);
      return;
    }

    const isDesktop = window.matchMedia('(min-width: 1024px)').matches;
    const sectionId = section.dataset.sectionId;
    
    if (!window.scrollerInstances) window.scrollerInstances = {};
    if (!window.stickerInstances) window.stickerInstances = {};

    // Clean up existing instances
    if (window.scrollerInstances[sectionId]) {
      window.scrollerInstances[sectionId].onUnload();
    }
    if (window.stickerInstances[sectionId]) {
      window.stickerInstances[sectionId].destroy();
    }

    // Initialize desktop scroller
    if (isDesktop) {
      document.body.classList.add('body-no-scroll');
      const mainScroller = new Scroller(section);
      window.scrollerInstances[sectionId] = mainScroller;
      
      // Initialize stickers with scroller context
      const stickerLayer = section.querySelector('.sticker-layer');
      if (stickerLayer) {
        window.stickerInstances[sectionId] = new DraggableStickers(stickerLayer, mainScroller);
      }
    } else {
      document.body.classList.remove('body-no-scroll');
      
      // Initialize stickers without scroller (mobile)
      const stickerLayer = section.querySelector('.sticker-layer');
      if (stickerLayer) {
        window.stickerInstances[sectionId] = new DraggableStickers(stickerLayer, null);
      }
    }
  };

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.horizontal-scroller-section').forEach(initFullScroller);
  });
  
  document.addEventListener('shopify:section:load', (e) => {
    if (e.target.matches('.horizontal-scroller-section')) initFullScroller(e.target);
  });
  
  document.addEventListener('shopify:section:unload', (e) => {
    const sectionId = e.target.dataset.sectionId;
    
    // Clean up scroller
    if (window.scrollerInstances && window.scrollerInstances[sectionId]) {
      window.scrollerInstances[sectionId].onUnload();
      delete window.scrollerInstances[sectionId];
      if (Object.keys(window.scrollerInstances).length === 0) {
        document.body.classList.remove('body-no-scroll');
      }
    }
    
    // Clean up stickers
    if (window.stickerInstances && window.stickerInstances[sectionId]) {
      window.stickerInstances[sectionId].destroy();
      delete window.stickerInstances[sectionId];
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stickers"] && !Shopify.designMode) return;
  try {
    
(function() {
  const StickerSection = class {
    constructor(section) {
      this.section = section;
      this.container = this.section.querySelector('.stickers-container');
      this.stickers = this.section.querySelectorAll('[data-sticker-item]');
      this.draggableInstances = [];
      this.init();
    }

    init() {
      // Wait for GSAP and Draggable to load
      if (typeof gsap === 'undefined' || typeof Draggable === 'undefined') {
        setTimeout(() => this.init(), 100);
        return;
      }

      this.stickers.forEach(sticker => {
        const draggableInstance = Draggable.create(sticker, {
          type: "x,y",
          bounds: this.container,
          inertia: true,
          edgeResistance: 0.85,
          onPress: () => {
            gsap.to(sticker, { 
              scale: 1.2, 
              rotation: gsap.utils.random(-15, 15), 
              duration: 0.2,
              ease: "power2.out"
            });
          },
          onRelease: () => {
            gsap.to(sticker, { 
              scale: 1, 
              rotation: 0,
              ease: "back.out(2)", 
              duration: 0.3 
            });
          },
          onClick: function() {
            // Prevent accidental clicks when dragging
            if (this.isDragging) {
              return false;
            }
          }
        });

        this.draggableInstances.push(draggableInstance[0]);
      });
    }

    destroy() {
      // Clean up draggable instances
      this.draggableInstances.forEach(instance => {
        if (instance && instance.kill) {
          instance.kill();
        }
      });
      this.draggableInstances = [];
      
      // Kill any GSAP animations on stickers
      if (typeof gsap !== 'undefined') {
        this.stickers.forEach(sticker => {
          gsap.killTweensOf(sticker);
        });
      }
    }
  };

  const initStickerSection = (section) => {
    const sectionId = section.dataset.sectionId;
    
    // Initialize global instances object
    if (!window.stickerSectionInstances) {
      window.stickerSectionInstances = {};
    }

    // Clean up existing instance
    if (window.stickerSectionInstances[sectionId]) {
      window.stickerSectionInstances[sectionId].destroy();
    }

    // Create new instance
    window.stickerSectionInstances[sectionId] = new StickerSection(section);
  };

  // Initialize on page load
  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.stickers-section').forEach(initStickerSection);
  });

  // Shopify Theme Editor events
  document.addEventListener('shopify:section:load', (e) => {
    if (e.target.querySelector('.stickers-section')) {
      initStickerSection(e.target.querySelector('.stickers-section'));
    }
  });

  document.addEventListener('shopify:section:unload', (e) => {
    const section = e.target.querySelector('.stickers-section');
    if (section) {
      const sectionId = section.dataset.sectionId;
      if (window.stickerSectionInstances && window.stickerSectionInstances[sectionId]) {
        window.stickerSectionInstances[sectionId].destroy();
        delete window.stickerSectionInstances[sectionId];
      }
    }
  });
})();

  } catch(e) { console.error(e); }
})();
})();
